import { render, staticRenderFns } from "./m-confirmation-pull-up.vue?vue&type=template&id=8c797872&scoped=true&"
import script from "./m-confirmation-pull-up.ts?vue&type=script&lang=ts&"
export * from "./m-confirmation-pull-up.ts?vue&type=script&lang=ts&"
import style0 from "./m-confirmation-pull-up.scss?vue&type=style&index=0&id=8c797872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c797872",
  null
  
)

export default component.exports